export function cacheData (data) {
  return {
    type: 'CACHE_DATA',
    data
  }
}
